/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/masx_userlist.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_OPEN_INVITE_MASQUERADER_LIST } from "../graphql";
import { VApplication } from "../../../application";
import config1 from "../config/useremail.config.json";
import moment from "moment-timezone";
import { pretty } from "@vlinder-web/utils-react";
import { ManageOpenRegistraionService } from "..";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const is = require("is_js");
export interface IMasqueraderListsMethods extends IPluginMethodMap {
  getMasqueraderListsProps(args: any): Promise<any>;
}
const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    "services.ManageOpenRegistraionService"
  ) as ManageOpenRegistraionService;
};
export class MasqueraderListsService implements IAgentPlugin {
  readonly methods: IMasqueraderListsMethods;

  constructor() {
    this.methods = {
      getMasqueraderListsProps: this.getMasqueraderListsProps.bind(this),
    };
  }

  async getMasqueraderListsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let filter = {};

    const searchType = this.determineSearchType(args?.criteria);
    if (searchType && searchType !== null) {
      if (searchType === "multi") {
        filter = this.getMultiFilter(args?.criteria);
      }
      //  else if (searchType === "status") {
      //   filter = this.convertDropDown(args?.criteria);
      // }
      else {
        filter = this.convertCriteria(args?.criteria);
      }
    }

    const options = {
      limit: args?.size ?? 10,
      skip: args?.offset ?? 0,
    };

    const renderPresentation = async () => {
      const data1 = await getSrv()?.getInviteUser();

      let presentation =
        data1?.response?.getOpenInvite[0]?.presentation?.id ?? "";

      return presentation;
    };

    console.log("filter in service====", options);
    try {
      if (client) {
        const res = await client.query({
          query: GET_OPEN_INVITE_MASQUERADER_LIST,
          variables: {
            options: options,
            presentationId: await renderPresentation(),
            invitedByUserEmail: config1?.userEmail,
            filter: filter,
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log("data for userTable====", pretty(res?.data));
          let _rowData = this.formatUserTable(
            res?.data?.getUsersWithBoxes?.content
          );

          let _totalPages = res?.data?.getUsersWithBoxes?.count
            ? Math.ceil(parseInt(res?.data?.getUsersWithBoxes?.count) / 10)
            : 1;

          let _currentPage =
            res?.data?.getUsersWithBoxes?.skip /
            res?.data?.getUsersWithBoxes?.limit +
            1;
          console.log(
            "pagination====",
            _totalPages,
            _currentPage,
            res?.data?.getUsersWithBoxes?.count
          );
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getUsersWithBoxes?.content?.length <= 0,
            activePage: _currentPage,
            pageSize: res?.data?.getUsersWithBoxes?.limit,
            totalCount: res?.data?.getUsersWithBoxes?.count,
            totalPages: _totalPages,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return "suspended";
    } else {
      switch (status) {
        case "USER_ADDED":
          return "created";
        case "USER_INVITED":
          return "invited";
        case "USER_VERIFIED":
          return "active";
        case "USER_ACC_CREATED":
          return "active";
        case "SUSPENDED":
          return "suspended";
        default:
          return "-";
      }
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any = [];
    for (let i = 0; i < data?.length; i++) {
      console.log("row data======", data[i]);
      let value = data[i]?.Boxes[0];
      if (value != undefined) {
        _rowData.push({
          id: value?.id,
          name: value?.user?.firstName,
          email: value?.user?.email,
          gender: data[i]?.gender ?? "-",
          status: data[i]?.inviteStatus,
          partition:
            data[i]?.Referal?.partition ??
            "-",
          section: value?.section?.name,
          sectionOption: value?.items[0]?.costumeType?.name ?? "-",
          paymentStatus: value?.paymentStats,
          costumeID: value?.costumeID,
          boxStatus: value?.boxStatus,
          createdAt: data[i]?.createdAt ? this.formatCreatedDate(data[i]?.createdAt) : " ",
          amountPaid: value.amountPaid ?? 0,
          totalAmount: value?.totalAmount ?? 0,
        });
      } else {
        _rowData.push({
          id: data[i]?.id,
          name: data[i]?.fullName ?? data[i]?.email ?? "",
          email: data[i]?.email ?? "-",
          gender: data[i]?.gender ?? "-",
          status: data[i]?.inviteStatus,
          partition:
            data[i]?.Referal?.partition ??
            "-",
          createdAt: data[i]?.createdAt ? this.formatCreatedDate(data[i]?.createdAt) : " ",
          section: "-",
          sectionOption: "-",
          paymentStatus: "-",
          costumeID: "-",
          boxStatus: "-",
          amountPaid: "-",
          discountAmount: "-",
          totalAmount: "-",
        });
      }
    }
    return _rowData;
  }

  private determineSearchType(criteria: any) {
    if (Object.keys(criteria).length === 0) {
      return "default";
    }
    // else if (Object.keys(criteria)[0] === "status") {
    //   return "status";
    // }
    else if (Object.keys(criteria)[0] === "0") {
      return "multi";
    } else {
      return "normal";
    }
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format("LLL");
    }
  }

  private convertCriteria(criteria: any) {
    const result: any = {};
    for (const key in criteria) {
      console.log("key in convert criteria", key, criteria[key]);
      if (key === "inviteStatus" && criteria[key] === "all") {
        console.log("not filter")
      }
      else {
        result[key] = { contains: criteria[key] };
      }
    }
    return result;
  }

  private convertDropDown(criteria: any) {
    console.log("dropdoewn", Object.values(criteria)[0]);
    const result: any = {};
    for (const key in criteria) {
      result["Boxes___boxStatus"] = Object.values(criteria)[0];
    }
    return result;
  }

  private getMultiFilter(criteria: any) {
    const transformedCriteria: any = {};
    for (const key in criteria) {
      if (criteria.hasOwnProperty(key)) {
        const { key: filterKey, filters } = criteria[key];
        const { inputData } = filters;
        const filterType = Object.keys(filters).find(
          (key) => key !== "inputData"
        );

        transformedCriteria[inputData.id] = {
          [filterType.toLowerCase().replace("equal", "eq")]:
            filters[filterType],
        };
      }
    }
    return transformedCriteria;
  }
}
